import * as React from 'react'
// components
import { Avatar } from 'components/UI'

interface Props {
  list: any[]
  limit: number
}

const AvatarsList: React.FC<Props> = ({ list, limit }) => {
  return (
    <>
      {list.slice(0, limit + 1).map((role, i) => {
        const id = role?.user?.id || role?.position?.id
        const user = role?.user || role?.position

        if (i === limit && list.length > limit + 1) {
          return <Avatar key={id} counter={`+${list.length - i}`} />
        }

        return <Avatar key={id} withHover user={user} />
      })}
    </>
  )
}

export default AvatarsList
